module.exports = __webpack_public_path__ + "img/upload.c218f38c.svg";